import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';

import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import {AuthService} from '../core/auth.service';
import {AlertService} from '../widgets/alert/alert.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private translate: TranslateService;
  private authService: AuthService;

  private refreshTokenInProgress = false;
  private tokenRefreshedSource = new Subject();
  private tokenRefreshed = this.tokenRefreshedSource.asObservable();

  constructor(private alertService: AlertService, private router: Router, injector: Injector) {
    setTimeout(() => {
      this.translate = injector.get(TranslateService);
      this.authService = injector.get(AuthService);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .catch((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 409 && err.error.errorCode === 4016) {
            this.handleConflict();
            return;
          }
          if (err.error.error && err.status === 401 && err.error.error === 'invalid_token'
            && err.error.error_description.indexOf('Invalid refresh token (expired):') === -1) {
            return this.refreshToken().switchMap(
              () => {
                return this.resendRequestWithNewToken(req, next);
              });
          } else if (err.error.error && ((err.status === 400 && err.error.error === 'invalid_grant')
              || (err.status === 401 && err.error.error_description.indexOf('Invalid refresh token (expired):') !== -1))) {
            this.refreshTokenInProgress = false;
            this.authService.setRedirectUrl();
            this.authService.logOut();
            this.router.navigate(['/login']);
          }
          this.showAlert(err);
        }
      });
  }

  private refreshToken() {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      return this.authService.refreshAccessToken()
        .do((JWT) => {
            this.authService.sessionService.setJWT(JWT);
            this.refreshTokenInProgress = false;
            this.tokenRefreshedSource.next();
          },
          (err) => {
            this.refreshTokenInProgress = false;
          });
    }
  }

  private resendRequestWithNewToken(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'))
    }));
  }

  private handleConflict(): void {
    this.translate.get('OPTIMISTIC_LOCK', {}).subscribe((res: string) => {
      this.alertService.error(res);
    });
  }

  private showAlert(err: HttpErrorResponse) {
    if (err.error.error_description) {
      const displayErrorMessage = err.error.error_description;
      if (displayErrorMessage === 'Bad credentials') {
        this.translate.get('ERROR.4001', {}).subscribe((res: string) => {
          this.alertService.error(res);
        });
      } else if (err.error.error === 'invalid_token' || err.error.error === 'invalid_grant') {
        this.translate.get('ALERT.TOKEN_EXPIRED', {}).subscribe( (res: string) => {
          this.alertService.error(res);
        });
      } else {
        this.alertService.error(err.error.error_description);
      }
      return;
    }
    const code = err.error.errorCode ? err.error.errorCode : 'DEFAULT';
    this.translate.get('ERROR.' + code, {}).subscribe((res: string) => {
      this.alertService.error(res);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/error.interceptor.ts